import React from 'react'
import PropTypes from 'prop-types'

import Carousel from 'components_v2/Home/SignedIn/common/components/Carousel/Carousel'
import { Box } from 'ui/acro'
import { H5 } from 'ui/bend'

import MyEventCarouselCard from './MyEventCarouselCard'
import EventCarouselCard from 'components_v1/EventsView/Cards/EventCarouselCard'
import { EVENTS_CAROUSEL_BREAKPOINTS } from './eventsCarouselBreakpoints'

const PastEventsCarousel = ({ events, totalCount }) => {
  if (!events?.length) return null

  const pastEvents = events.map((event) => ({ ...event, isPast: true }))

  return (
    <Box mt={['40px', null, '56px']}>
      <H5
        as='h2'
        px={['0px', '16px', '16px', '0px']}
        mb={['16px', '16px', '16px', '24px']}
        style={{
          color: '#000',
          padding: '0px',
          fontSize: '20px',
          textTransform: 'uppercase'
        }}
      >
        Past Events
      </H5>
      {totalCount && (
        <div style={{ marginBottom: '4px' }}>{totalCount} Events</div>
      )}
      <Carousel
        card={EventCarouselCard}
        data={pastEvents}
        slug='past-events'
        carouselTitle='PastEvents'
        breakpoints={EVENTS_CAROUSEL_BREAKPOINTS}
      />
    </Box>
  )
}

PastEventsCarousel.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object)
}

export default PastEventsCarousel
